import { Grid, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ProviderConnectionCard } from "@/components/pages/integrations/components/provider-connections/grid-view/components/data-source-integration-card/ProviderConnectionCard";
import { useGetUsersMeProviderConnectionsSnowflakeQuery } from "@/services/cloudchipr.api";

// todo: Change this to work for all provider connections when adding the second provider connection.
export const ProviderConnectionsGridView = () => {
  const { data: snowflakeProviderConnections } =
    useGetUsersMeProviderConnectionsSnowflakeQuery();

  const connectionsCount = snowflakeProviderConnections?.length ?? 0;

  return (
    <Grid
      container
      spacing={2}
      pr={4}
      pb={2}
      columns={{ xs: 2, lg: 3, xl: 3, xxl: 4 }}
    >
      <Grid item xs={1} key={"snowflake"}>
        <Link
          underline="none"
          color="inherit"
          component={RouterLink}
          to={`/integrations/${"snowflake"}`}
        >
          <ProviderConnectionCard
            key={"snowflake"}
            type={"snowflake"}
            connections={connectionsCount}
          />
        </Link>
      </Grid>
    </Grid>
  );
};
